<template>
    <div class="box global-popup-inner global-popup-inner-delete df fdc" v-on:click="stopProp($event)">
      <div class="popup-top df">
        <img src="/images/warning-icon.png" alt="">
        <div class=f1>
          <p class="popup-title gg-font">Unable to Create Project</p>
          <p class="popup-text gg-font">You've reached the limit of projects for your plan.</p>
        </div>
      </div>
      <div class="popup-bottom">
        <p class="popup-text gg-font popup-sub-heading">
          Please upgrade to create more projects.
        </p>
        <span class="buttons df jcfe">
          <button class="popup-accept-button gg-font" @click="closePopup()">
            Ok
          </button>
        </span>
      </div>
    </div>
</template>

<script>
const axios = require('axios')

export default {
  name: 'PopupUpgrade',
  data () {
    return {
      comments: '',
      shareEmails: '',
      shareType: 'view'
    }
  },
  props: ['closePopup'],
  components: {
  },
  methods: {
    exportPrices () {
      var data = {
        columns: {...this.$store.getters.currentProjectModuleColumns},
        modules: [...this.$store.getters.currentProjectModules]
      }
      axios({
          method: 'POST',
          url: '/exportprices',
          data: data,
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(function (response) {
        // console.log('response', response);
        console.log('RESPONSE 1', response.data.downloadurl)
        var link = document.createElement("a");
        link.download = 'PricingData';
        link.href = response.data.downloadurl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.log('ERROR 1', error.response);
      })
      .then(function () {
        // always executed
      });
    },
    doExport () {
      this.exportPrices()
      this.$store.dispatch('showGlobalPopup', {show: true})
      this.$store.dispatch('popupExportProjectData', {show: false})
      this.closePopup()
    },
    setShareType (type) {
      this.shareType = type
      this.makeChanges(true)
    },
    stopProp (e) {
      e.stopPropagation()
    },
    makeChanges (changesMade) {
      this.changesMade = changesMade
    },
    doShare () {
      console.log('do share...')
      if (this.validateShareProject()) {
        console.log('doShare', window.location)
        var data = {
          projectid: this.$route.params.projectid,
          emails: this.validateShareProject(),
          message: this.comments,
          url: window.location,
          shareType: this.shareType
        }
        this.$store.dispatch('doShare', data).then(() => {
          console.log('after doShare')
          this.closePopup()
        })
      }
    },
    validateShareProject () {
      var emails = this.shareEmails.split(',')
      emails = emails.map(v => v.trim())
      emails = emails.filter(v => v !== '')
      emails = emails.filter(v => this.validateEmail(v))

      if (emails.length > 0) {
        return emails
      }
      return false
    },
    validateEmail(email) {
      console.log('validating this email', email)
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    deleteProject (id) {
        this.$store.dispatch('deleteProject', {
            projectID: id,
            userID: this.$store.getters.uid
        }).then(() => {
          this.closePopup()
        })
    },
  },
  computed: {

  },
  watch: {
  },
  mounted () {
  },
  created () {
    console.log('==>', this.$route);
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetails
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
        case 'REMOVE_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
      }
    })
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetailsFull
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT_FULL':
          setTimeout(() => {
            this.myProjectDetailsListFull = this.$store.getters.myProjectListWithDetailsFull
          }, 100)
          break
      }
    })
  }
}
</script>

<style scoped lang="scss">
</style>
